
<template>
	<div id="main-navbar" class="relative">
		<div class="relative vx-navbar-wrapper">

			<vs-navbar class="vx-navbar navbar-custom relative">

			<menu-principal />

			<vs-spacer></vs-spacer>

			<user-settings />

			</vs-navbar>
		</div>
	</div>
</template>

<script>

import MenuPrincipal from "../menu_principal/MenuPrincipal";
import UserSettings from "../user_settings/UserSettings";
import Colaborador from '../../models/Colaborador';

export default {
	name: "the-navbar",
	data() {
		return {
			searchQuery: "",
			showFullSearch: false,
			value1: null,
			autoFocusSearch: false,
			showBookmarkPagesDropdown: false
		};
	},
	components: {
		UserSettings,
		MenuPrincipal
	},
	computed: {
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
		temColaborador() {
			return Colaborador.hasColaborador();
		},
	},

};
</script>

<style lang="scss">
	#main-navbar {
		.vx-navbar-wrapper {
			width: 100%;
			height: auto !important;

		}


		.vs-navbar.vx-navbar {
			width: 100%;
			background: white !important;
		}

		@media (max-width: 1000px) {
			.vs-con-items {
				flex-direction: column !important;
			}
		}

	}
</style>
